import {CostAvoidanceAssetValuesForRange, CostAvoidanceForRange} from '../../../interfaces/api'
import {useUrlParam} from '../../useUrlParam'
import {usePlannerQuery} from '../usePlannerQuery'

export type CostAvoidanceForRangeData = CostAvoidanceForRange & {
  total: {
    electricityConsumed: number
    electricityCost: number
    costAvoidance: number
    producedTonnes: number
  }
}

export const useCostAvoidanceForRangeQuery = ({
  scheduleId,
  isDisabled = false,
  from,
  to
}: {
  scheduleId: number
  isDisabled?: boolean
  from: string
  to: string
}) => {
  const plantCode = useUrlParam('plantCode')
  return usePlannerQuery('costAvoidanceForRange', [{plantCode, scheduleId, from, to}], {
    enabled: !isDisabled,
    select: (data) => {
      const totalInit: CostAvoidanceAssetValuesForRange = {
        electricityConsumed: 0,
        electricityCost: 0,
        costAvoidance: 0,
        producedTonnes: 0
      }
      if (!data.assets) {
        return undefined
      }
      const total = Object.values(data.assets).reduce(
        (prev, next) => ({
          electricityConsumed: prev.electricityConsumed + next.electricityConsumed,
          electricityCost: prev.electricityCost + next.electricityCost,
          costAvoidance: prev.costAvoidance + next.costAvoidance,
          producedTonnes: prev.producedTonnes + next.producedTonnes
        }),
        totalInit
      )

      return {
        ...data,
        total
      } as CostAvoidanceForRangeData
    }
  })
}
